"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get PRESCRIPTION_LIMITS () {
        return PRESCRIPTION_LIMITS;
    },
    get PRESCRIPTION_VOID_REASONS () {
        return PRESCRIPTION_VOID_REASONS;
    },
    get PRESCRIPTION_VOID_REASON_LABELS () {
        return PRESCRIPTION_VOID_REASON_LABELS;
    },
    get PrescriptionStatusSchema () {
        return PrescriptionStatusSchema;
    },
    get PrescriptionVoidReasonSchema () {
        return PrescriptionVoidReasonSchema;
    }
});
const _zod = require("zod");
const PrescriptionStatusSchema = _zod.z.enum([
    'draft',
    'issued',
    'voided'
]);
const PRESCRIPTION_LIMITS = {
    itemsMax: 20,
    genericName: 120,
    strength: 40,
    brandName: 80,
    sig: 200,
    durationDaysMin: 1,
    durationDaysMax: 365,
    quantityMin: 1,
    quantityMax: 9999,
    refillsMax: 5,
    upsc: 64,
    voidNote: 200
};
const PRESCRIPTION_VOID_REASONS = [
    'entered_in_error',
    'wrong_patient',
    'wrong_medication',
    'wrong_dose',
    'patient_declined',
    'other'
];
const PrescriptionVoidReasonSchema = _zod.z.enum(PRESCRIPTION_VOID_REASONS);
const PRESCRIPTION_VOID_REASON_LABELS = {
    entered_in_error: 'Entered in error',
    wrong_patient: 'Wrong patient',
    wrong_medication: 'Wrong medication',
    wrong_dose: 'Wrong dose or instructions',
    patient_declined: 'Patient declined',
    other: 'Other'
};
